import classNames from 'classnames';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  className?: string;
};

export const BlogPagesShowOnMobile: React.FC<Props> = ({
  children,
  className,
}) => <div className={classNames('lg:hidden', className)}>{children}</div>;
